module.exports = __webpack_public_path__ + "img/roles_12.82b9ba54.png";